module.exports = __webpack_public_path__ + "img/coding1.f0b0f118.png";